export default __webpack_public_path__ + "static/media/Vector52.f68def04.png";